import React from 'react';

const SearchIcon = () => {
  return <div className="vbz-icon-beneficiaries-search" />;
};

export default SearchIcon;
